module.exports = __webpack_public_path__ + "media/images/logo-4915f930.svg";